<template>
  <div id="modal-affiliations-experience" :class="{'experience':type=='experience'}">
    <div class="content-box">
      <div class="text-right mb-3">
        <button class="btn" @click="close">close</button>
      </div>
      <div class="affiliations-content">
        <div class="row">
          <div class="col-md-9">
            <h3 class="title-1">{{title[type].title}}</h3>
            <div class="row">
              <div class="col-md-6">
                <div class="list shadow">
                  <div class="images"></div>
                  <div class="description">
                    <h5>Experience name</h5>
                    <ul class="detail">
                      <li>
                        Owner:
                        <span>owner name</span>
                      </li>
                      <li>
                        Category:
                        <span>STAY | Hotel | Boutique</span>
                      </li>
                      <li>
                        Listing Date:
                        <span>24/11/2020</span>
                      </li>
                    </ul>
                    <div class="hastag">#theroyalwinghotel</div>
                    <div class="lastupdate">
                      <span class="time">Last update: 3m ago</span>
                      <span class="kk">300m</span>
                    </div>
                  </div>
                  <div class="status">
                    <div class="top approve">
                      <div class="arrow-left"></div>
                      <img :src="statusIcon[0].icon" :alt="statusIcon[0].name" />
                    </div>
                    <div class="bottom approve">
                      <div class="arrow-right"></div>
                      <img :src="statusIcon[0].icon" :alt="statusIcon[0].name" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <b-pagination :total-rows="100" :per-page="1" first-number last-number align="center">
                <template v-slot:prev-text>
                  <span>
                    <i class="fas fa-caret-left"></i>
                    <span class="text-pagination">PREVIOUS</span>
                  </span>
                </template>
                <template v-slot:next-text>
                  <span>
                    <span class="text-pagination">NEXT</span>
                    <i class="fas fa-caret-right"></i>
                  </span>
                </template>
              </b-pagination>
            </div>
          </div>
          <div class="col-md-3">
            <h3 class="title-2 mt-5">{{title[type].filter}}</h3>
            <div class="filter">
              <div class>
                <input type="text" placeholder="Search experiences" />
              </div>
              <div class>
                <label class="container-checkbox">
                  Only show my own experiences
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="btn-status">
                <div class="row">
                  <div class="col-md-4">
                    <button type="button" class="btn-chilp btn-block">Connected</button>
                  </div>
                  <div class="col-md-4">
                    <button type="button" class="btn-chilp btn-block">Requested</button>
                  </div>
                  <div class="col-md-4">
                    <button type="button" class="btn-chilp btn-block">Rejected</button>
                  </div>
                </div>
              </div>
              <div class="by">
                <label class="container-checkbox">
                  By me
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
                <label class="container-checkbox">
                  By other experiences
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="mb-3">
                <select name id>
                  <option value>Sort by listing date</option>
                  <option value>Sort by last update</option>
                  <option value>Sort by name A...Z</option>
                  <option value>Sort by name Z...A</option>
                  <option value>Sort by Proximity</option>
                  <option value>Sort by owner A...Z</option>
                  <option value>Sort by owner Z...A</option>
                </select>
              </div>
              <div class="mb-3">
                <vue-tags-input
                  v-model="tag"
                  :tags="tags"
                  placeholder="All hashtags"
                  :autocomplete-items="filteredItems"
                  @tags-changed="newTags => tags = newTags"
                />
                <div class="text-right">
                  <span class="b-reset" @click="tags = []">reset hashtags</span>
                </div>
              </div>
              <div class="categories">
                <h5>Categories</h5>
                <div>
                  <button type="button" class="btn-chilp mr-2 mb-2">DO</button>
                  <button type="button" class="btn-chilp mr-2 mb-2">STAY</button>
                  <button type="button" class="btn-chilp mr-2 mb-2">SHOP</button>
                  <button type="button" class="btn-chilp mr-2 mb-2">MOVE</button>
                  <button type="button" class="btn-chilp mr-2 mb-2">TASTE</button>
                  <button type="button" class="btn-chilp mr-2 mb-2">OTHERS</button>
                </div>
                <div class="text-right">
                  <span class="b-reset">reset categories</span>
                </div>
              </div>
              <div class="location mb-3">
                <h5>Location</h5>
                <select name id>
                  <option value>Country</option>
                </select>
                <select name id>
                  <option value>Region</option>
                </select>
                <select name id>
                  <option value>City/District</option>
                </select>
                <div class="text-right">
                  <span class="b-reset">reset location</span>
                </div>
              </div>
              <div class="submit">
                <button class="btn btn-apply" type="button">
                  <span class="mr-1">APPLY</span>
                  <img :src="statusIcon[0].icon" :alt="statusIcon[0].name" />
                </button>
                <button class="btn btn-reset" type="button">
                  <span class="mr-1">RESET FILTER</span>
                  <img :src="resetIcon" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import approveIcon from "@/assets/images/ew-icon_approved.svg";
import undecidedIcon from "@/assets/images/ew-icon_undecided.svg";
import pendingIcon from "@/assets/images/ew-icon_pending.svg";
import resetIcon from "@/assets/images/ew-icon_reset.svg";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  props: {
		value: {
			type: Array,
			default() {
				return [];
			},
		},
    type: {
      type: String,
      default: "",
    },
  },
  components: {
    VueTagsInput,
  },
  data() {
    return {
      title: {
        experience: {
          title: "Affiliations",
          filter: "Filter Experiences",
        },
      },
      resetIcon: resetIcon,
      statusIcon: [
        {
          name: "approve",
          icon: approveIcon,
        },
        {
          name: "normal",
          icon: undecidedIcon,
        },
        {
          name: "request",
          icon: pendingIcon,
        },
      ],
      tag: '',
      tags: [],
      filteredItems: [],
      returnItems: []
    };
  },
  methods: {
    close() {
      this.$emit("close", []);
    },
  },
};
</script>

<style lang="scss">
#modal-affiliations-experience {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;
  padding-bottom: 30px;
  overflow-y: scroll;

  &.experience {
    .content-box {
      .affiliations-content {
        .title-1 {
          font-size: 24px;
          color: #1da1f2;
        }
        .title-2 {
          font-size: 18px;
          color: #1da1f2;
        }
      }
    }
  }

  .content-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 95%;

    .affiliations-content {
      padding: 30px;
      background-color: #fff;

      .list {
        display: flex;
        .images {
          width: 25%;
          background-color: #b9b9b9;
        }

        .description {
          width: 65%;
          padding: 10px 15px 5px 15px;

          .detail {
            list-style: none;
            padding: 0;

            li {
              font-size: 12px;
              span {
                font-weight: lighter;
              }
            }
          }

          .hastag {
            font-size: 18px;
            font-weight: bold;
          }

          .lastupdate {
            display: flex;
            justify-content: space-between;

            .time {
              font-size: 13px;
              font-weight: lighter;
            }

            .kk {
              font-size: 18px;
            }
          }
        }

        .status {
          display: flex;
          flex-wrap: wrap;
          width: 10%;
          .top,
          .bottom {
            position: relative;
            width: 100%;
            height: 50%;

            img {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }

          .top {
            border-bottom: 1px solid #fff;

            .arrow-left {
              position: absolute;
              left: -11px;
              width: 0;
              height: 0;
              border-top: 15px solid transparent;
              border-bottom: 15px solid transparent;
              border-right: 10px solid #1da1f2;
            }

            &.approve {
              .arrow-left {
                border-right: 10px solid #1da1f2;
              }
              background-color: #1da1f2;
            }
            &.normal {
              .arrow-left {
                border-right: 10px solid #58595b;
              }
              background-color: #58595b;
            }
            &.request {
              .arrow-left {
                border-right: 10px solid #58595b;
              }
              background-color: #58595b;
            }
          }

          .bottom {
            border-top: 1px solid #fff;
            .arrow-right {
              position: absolute;
              left: 1px;
              width: 0;
              height: 0;
              border-top: 15px solid transparent;
              border-bottom: 15px solid transparent;
              border-left: 10px solid #fff;
            }

            &.approve {
              background-color: #1da1f2;
            }
            &.normal {
              background-color: #58595b;
            }
            &.request {
              background-color: #58595b;
            }
          }
        }

        &:hover {
          border: 2px solid #1da1f2;

          .description {
            padding: 8px 15px 2px 15px;
          }
        }
      }
    }

    .filter {
      input[type="text"] {
        width: 100%;
      }

      select {
        width: 100%;
      }

      .btn-chilp {
        color: #fff;
        font-size: 12px;
        padding-left: 15px;
        padding-right: 15px;
        height: 30px;
        border-radius: 15px;
        background-color: #1da1f2;
      }

      .by {
        display: flex;
        justify-content: space-between;
      }

      .categories {
        h5 {
          font-size: 14px;
        }
      }

      .location {
        h5 {
          font-size: 14px;
        }

        select {
          margin-bottom: 5px;
        }
      }

      .submit {
        display: flex;
        justify-content: space-between;
        .btn {
          width: 49%;
          font-size: 14px;

          &.btn-apply {
            background-color: #1da1f2;
          }

          &.btn-reset {
            background-color: #58595b;
          }
        }
      }

      .b-reset {
        cursor: pointer;
        color: #B9B9B9;
        font-size: 12px;
        font-weight: lighter;
        text-decoration: underline;
      }

      .vue-tags-input {
        max-width: initial !important;

        .ti-input {
          min-height: 150px;
        }

        .ti-tags {
          align-items: flex-start;
        }

        .ti-tag {
          border-radius: 15px;
          padding: 5px 10px;
        }

        .ti-tag,
        .ti-selected-item {
          background-color: #1da1f2;
          color: white;
        }

        .ti-autocomplete {
          color: black;
        }
      }
    }
  }

  /* The container */
  .container-checkbox {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-size: 14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 7px;
    left: 10px;
    height: 15px;
    width: 15px;
    background-color: #eee;
  }

  /* On mouse-over, add a grey background color */
  .container-checkbox:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container-checkbox input:checked ~ .checkmark {
    background-color: #1da1f2;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container-checkbox input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container-checkbox .checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .pagination .page-item.active .page-link {
    background-color: #1da1f2;
  }
}
</style>